// extracted by mini-css-extract-plugin
module.exports = {"item":"W2HowToGet_item__Dtftq","item__title":"W2HowToGet_item__title__J05NE"};